<template>
  <RevStickyBar class="block md:hidden">
    <InstallmentPaymentPrice
      v-if="monthlyPaymentPlan"
      class="pb-12"
      :monthly-payment-plan="monthlyPaymentPlan"
    />

    <div class="flex items-center">
      <div class="grow">
        <Price :color="priceColor" :offer="offer" :product="product" />
        <p
          v-if="!monthlyPaymentPlan && emphasisLabel"
          class="caption-bold"
          :class="priceColor"
        >
          {{ emphasisLabel }}
        </p>
      </div>
      <RevButton
        class="ml-8 grow"
        data-qa="product-page-buy-button-mobile"
        variant="primary"
        @click="onAddToCart"
      >
        {{ i18n(translations.addToCart) }}
      </RevButton>
    </div>
  </RevStickyBar>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { productAPI } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevStickyBar } from '@ds/components/StickyBar'

import { InstallmentPaymentPrice } from '~/scopes/payment'

import { useAddToCart } from '../../composables/useAddToCart'
import { useProductTracking } from '../../composables/useProductTracking'
import Price from '../Price/Price.vue'

import translations from './StickyBarBottom.translations'

const i18n = useI18n()

const props = defineProps<{
  offer: productAPI.GetBestOffersResponse[number]
  product: productAPI.GetProductResponse
  swapStatus?: string
  tracking: ReturnType<typeof useProductTracking>
  emphasisColor?: 'info' | 'accent' | undefined
  emphasisLabel?: string | undefined
}>()

const { addToCart } = useAddToCart()

const monthlyPaymentPlan = computed(() => {
  return props.offer.installmentMonthlyPaymentPlan
})

const colors = {
  info: 'text-action-brand-hi-pressed',
  accent: 'text-action-brand-mid',
}

const priceColor = computed(() => {
  if (props.emphasisColor && props.emphasisColor in colors) {
    return colors[props.emphasisColor]
  }

  return ''
})

function onAddToCart() {
  addToCart({
    listingId: props.offer.id,
    tracking: {
      ...props.tracking.product.value,
      list: 'product_page',
    },
    swapStatus: props.swapStatus || '',
  })
}
</script>
